import { Stack } from '@landler/component-library';
import { useState } from 'react';

import { AgentType, Message } from '@/api/rest/resources/types/conversation';
import { CurrentChat } from '@/components/CoPilot/components/Chat';
import { useUser } from '@/lib/auth';
import { useSetOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { isNullish } from '@/utils/booleans';

import { ConversationsPanel, CurrentConversationPanelHeader } from './CopilotConversations.page';

enum ConversationTab {
  all = 'all',
  user = 'user',
  annotations = 'annotations',
}

export const GlobalCopilotConversationsPage = () => {
  const user = useUser();
  const setOrganizationId = useSetOrganizationId();

  const [activeTab, setActiveTab] = useState<ConversationTab>(ConversationTab.all);

  const [activeConversationId, setActiveConversationId] = useState<string | null>(null);
  const [selectedMessageId, setSelectedMessageId] = useState<string | null>(null);

  const handleSelectAnnotation = (message: Message | null) => {
    if (isNullish(message)) {
      setActiveConversationId(null);
      setSelectedMessageId(null);
      return;
    }
    setActiveConversationId(message.conversation_id);
    setSelectedMessageId(message.id);
  };

  const handleSelectConversation = (id: string | null, organizationId?: string | null) => {
    setActiveConversationId(id);
    setSelectedMessageId(null);
    if (id && organizationId) {
      setOrganizationId(organizationId);
    }
  };

  return (
    <div className='flex h-[calc(100vh-180px)] min-h-[500px] overflow-hidden rounded-xl border border-neutral-black-12'>
      <Stack className='flex flex-1 flex-col overflow-hidden'>
        <CurrentConversationPanelHeader
          activeConversationId={activeConversationId}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <Stack className='p-5 flex-1 overflow-hidden flex flex-col'>
          {activeConversationId && (
            <CurrentChat
              key={`current-chat-${activeConversationId}`}
              activeAgentType={AgentType.copilot}
              conversationIdArg={activeConversationId}
              highlightedMessageId={selectedMessageId}
            />
          )}
        </Stack>
      </Stack>
      <ConversationsPanel
        activeTab={activeTab}
        onTabChange={setActiveTab}
        activeConversationId={activeConversationId}
        currentUserId={user?.email ?? null}
        onSelectConversation={handleSelectConversation}
        selectedMessageId={selectedMessageId}
        onSelectAnnotation={handleSelectAnnotation}
        showGlobal={true}
      />
    </div>
  );
};
